<template>
  <div class="list-view-type-tabs">
    <ul class="list-view-type-tabs__list" ref="tabsList">
        <li
            class="list-view-type-tabs__item"
            v-for="(tab, index) in tabs"
            :key="index"
            :class="[{'-active': activeTab === tab.value}, tab.value, {'-disabled': tab.count === 0}]"
            @click="switchTab(tab)"
            v-if="tab.count > 0 || (noResultsSearchResults && noResultsSearchResults.view_type_count[tab.value] > 0)"
        >
            <span class="list-view-type-tabs__label">{{ $t(tab.label) }}</span>
            <span class="list-view-type-tabs__count">({{ tab.count }})</span>
        </li>
    </ul>
  </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { mapOrderTypeToSortValue, orderTypes } from 'store/shared/sorterOptions'
    import { viewTypes } from '@/store/modules/search'

    export default {
        name: 'SearchListViewTypeTabs',
        props: {
            isPackageCustomerCustom: {
                type: Boolean
            }
        },
        data () {
            return {
                tabsRouteNames: {
                    learning_paths: 'learning-paths',
                    collections: 'collection-list',
                    courses: 'course-list',
                    live: 'live-events',
                    virtual_classrooms: 'virtual-classrooms',
                    all: 'all-content'
                }
            }
        },
        computed: {
            ...mapGetters({
                activeTab: 'Search/getViewType',
                viewTypeCounts: 'Search/viewTypeCounts',
                searchInProgress: 'Search/isSearchInProgress',
                currentUser: 'User/getCurrentUser',
                isLoggedIn: 'isLoggedIn',
                noResultsSearchResults: 'Search/getNoResultsSearchResult',
                searchQuery: 'Search/searchQuery'
            }),
            tabs () {
                const viewTypeTabs = [
                    { value: 'all', label: 'CourseItemTypeTabs.all_content', count: this.viewTypeCounts.all },
                    { value: 'learning_paths', label: 'CourseItemTypeTabs.learning_paths', count: this.viewTypeCounts.learning_paths },
                    { value: 'collections', label: 'CourseItemTypeTabs.collections', count: this.viewTypeCounts.collections },
                    { value: 'courses', label: 'CourseItemTypeTabs.courses', count: this.viewTypeCounts.courses },
                    { value: 'live', label: 'CourseItemTypeTabs.live_events', count: this.viewTypeCounts.live },
                    { value: 'virtual_classrooms', label: 'CourseItemTypeTabs.virtual_classrooms', count: this.viewTypeCounts.virtual_classrooms }
                ]
                if (this.isLoggedIn && !this.hasAccessToDigitalClassrooms && this.hasAccessToDigitalClassrooms !== null) {
                    return viewTypeTabs.filter(viewTypeTab => viewTypeTab.value !== 'virtual_classrooms')
                }
                return viewTypeTabs
            },
            hasAccessToDigitalClassrooms () {
                return this.currentUser.hasAccessToDigitalClassrooms
            }
        },
        methods: {
            switchTab (tab) {
                if (tab.count === 0) {
                    return
                }
                this.$store.dispatch('Search/setViewType', tab.value)

                switch (tab.value) {
                    case viewTypes.collections:
                    case viewTypes.courses:
                        this.$store.dispatch('Search/setSort', mapOrderTypeToSortValue(orderTypes.NEW_TO_OLD))
                        break
                    case viewTypes.liveEvents:
                    case viewTypes.virtualClassrooms:
                        this.$store.dispatch('Search/setSort', mapOrderTypeToSortValue(orderTypes.OLD_TO_NEW))
                        break
                    case viewTypes.all:
                        this.$store.dispatch('Search/setSort', mapOrderTypeToSortValue(orderTypes.A_TO_Z))
                }

                if (Object.keys(this.$route.params).length === 0) {
                    this.$router.replace({ name: 'all-packages-' + this.tabsRouteNames[tab.value] })
                } else {
                    this.$router.replace({ name: this.tabsRouteNames[tab.value] })
                }
            },
            doNotShowEmptyTabs () {
                if (this.searchInProgress) {
                    return
                }
                let isActiveTabEmpty = this.tabs.find(el => el.value === this.activeTab).count === 0

                if (this.isPackageCustomerCustom) {
                    if (isActiveTabEmpty && this.viewTypeCounts.collections > 0) {
                        this.$store.dispatch('Search/setViewType', viewTypes.collections)
                        this.$store.dispatch('Search/setSort', mapOrderTypeToSortValue(orderTypes.NEW_TO_OLD))
                        return
                    } else if (isActiveTabEmpty && this.viewTypeCounts.courses > 0) {
                        this.$store.dispatch('Search/setViewType', viewTypes.courses)
                        this.$store.dispatch('Search/setSort', mapOrderTypeToSortValue(orderTypes.NEW_TO_OLD))
                        return
                    }
                }

                if (isActiveTabEmpty && this.viewTypeCounts.all > 0) {
                    this.$store.dispatch('Search/setViewType', viewTypes.all)
                    this.$store.dispatch('Search/setSort', mapOrderTypeToSortValue(orderTypes.A_TO_Z))
                }
            },
            switchTabToMostContent () {
                const allZero = Object.values(this.viewTypeCounts).every(val => val === 0);
                if (allZero) {
                    return
                }
                const tabCount = this.$refs.tabsList.querySelectorAll('li').length
                if (tabCount > 2) {
                    this.$store.dispatch('Search/setViewType', viewTypes.all)
                }                
            }
        },
        watch: {
            activeTab: {
                handler: 'doNotShowEmptyTabs',
                immediate: true
            },
            viewTypeCounts: {
                handler: 'doNotShowEmptyTabs',
                immediate: true
            },
            searchQuery (query) {
                if (query !== '') {
                    this.switchTabToMostContent()
                }
            }
        }
    }
</script>
<style scoped lang="scss">
.list-view-type-tabs {
    padding: 30px 0;

    &__list {
        display: flex;
        flex-direction: row;
        border-bottom: 1px solid $alto;
        min-height: 40px;


        [class*="mobile"] & {
            height: 100%;
            overflow-x: auto;
            gap: 10px;
            scrollbar-width: none;
        }
    }

    &__item:not(:first-child) {
        [class*="desktop"] & {
            margin: 0 0 0 10px;
        }
    }

    &__item {
        padding: 0 20px;
        color: $tuatara;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-family: PlusJakartaSans-Medium, sans-serif;
        position: relative;
        background: $light_blue;
        border-radius: 5px 5px 0 0;
        gap: 5px;
    
        &:hover {
            color: $black;
        }

        [class*="desktop"] & {
            gap: 4px;
        }

        [class*="mobile"] & {
            padding: 6px 20px;
            font-size: 1.6rem;
        }

        &.-disabled {
            color: $boulder;
            cursor: default;
            background: $alto;
            &:hover:after {
                content: '\e94c';
                font-family: icomoon;
                font-size: 1.8rem;
                color: $chestnut;
                position: absolute;
                top: 5px;
                right: 0;
            }
        }

        &.-active {
            font-family: PlusJakartaSans-Bold, sans-serif;
            background: $lavender;
            border-radius: 5px 5px 0 0;
            color: $white;
        }
    }

    &__label {
        width: max-content;
    }
}
</style>
